import { ListItem } from '@tableau/widgets';

import { GeocodingConfig, GeocodingConfigsResponse } from '../requests/GeocodingConfigRequests';
import { GetDatasourceColumnsResponse } from '../requests/GetDatasourceColumns';

export class GeocodingResponseHelper {

  /** Process GetDatasourceColumnsResponse into colNameToCaptionMap<string, string> and Columns ListItem[] to be listed in config dialog*/
  public static processGetDatasourceColumnsResponse(response: GetDatasourceColumnsResponse): { columns: ListItem[], colNameToCaptionMap: Record<string, string> } {
    if (!response.datasourceColumns?.datasourceColumn) {
      return { columns: [], colNameToCaptionMap: {} };
    }

    // build up the column qualified name to caption map
    const colNameToCaptionMap: Record<string, string> = {};
    const cols = response.datasourceColumns.datasourceColumn;

    // filter columns that are supported
    const supportedColumns = cols.filter((col) =>
    col.role === 'DIMENSION' && (col.dataType === 'STRING' || col.dataType === 'INT'));

    // build columns and map from the column values
    const columns = Object.values(supportedColumns).map((col) => {
        colNameToCaptionMap[col.fullyQualifiedName] = col.name;
        return this.buildItem(col.name, col.fullyQualifiedName);
      }
    );

    // sort columns alphabetically
    columns.sort((a, b) => a.tooltip!.localeCompare(b.tooltip!));

    return { columns, colNameToCaptionMap };
  }

  private static buildItem(caption: string, qualifiedName: string): ListItem {
    return {
      value: qualifiedName,
      content: caption,
      tooltip: caption,
    };
  }

  /** Process GetGeocodingConfigsForDatasourceResponse into sorted config list */
  public static processGetGeocodingConfigsForDatasourceResponse(response: GeocodingConfigsResponse): GeocodingConfig[] {
    if (!response.geocodingConfigs?.geocodingConfig) {
      return [];
    }

    const configs = Object.values(response.geocodingConfigs.geocodingConfig).map((config) => {
        return {
          id: config.id,
          name: config.name,
          targetColName: config.targetColName,
          tokenLimit: config.tokenLimit
        };
      }
    );

    configs.sort((a, b) => a.name.localeCompare(b.name!));

    return configs;
  }
}